import { EnumeratedSetValue, IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

angular.module('data-ng-todos').factory('TodoFilterEnum', () => {
  return Enumeration.useDefinitionAsEnum({
    ALL_TODO_AND_EVENT: {
      name: 'All To-Dos and Events',
      stateParam: 'all',
      servantMethod: 'activeTodosAndEventsForToday',
      viewTitle: 'Today',
      emptyText: `There's nothing to do today. Keep scrolling to see what's coming up in the next week.`
    },
    TODAY_TODO: {
      name: `Today's To-Dos`,
      stateParam: 'todostoday',
      servantMethod: 'todosForToday',
      viewTitle: 'Today',
      emptyText: `You have no to-dos today.`
    },
    TODAY_EVENT: {
      name: `Today's Events`,
      stateParam: 'eventstoday',
      servantMethod: 'eventsForToday',
      viewTitle: 'Today',
      emptyText: `You have no events today.`
    },
    COMPLETED_TODO: {
      name: 'Completed',
      stateParam: 'completed',
      servantMethod: 'completedTodos',
      viewTitle: 'Completed',
      emptyText: `You haven't completed anything yet... \n Get going!`
    },
    OVERDUE_TODO: {
      name: 'Overdue',
      stateParam: 'overdue',
      servantMethod: 'overdueTodos',
      viewTitle: 'Overdue',
      emptyText: `You have nothing overdue... \n Good job!`
    },
    HIDDEN_TODO: {
      name: 'Hidden',
      stateParam: 'hidden',
      servantMethod: 'hiddenTodos',
      viewTitle: 'Hidden',
      emptyText: `You haven't hidden any steps yet.`
    },
    REMINDER: {
      name: 'Personal To-Dos',
      stateParam: 'reminders',
      servantMethod: 'allReminders',
      viewTitle: 'Personal To-Dos',
      emptyText: `You have no personal to-dos.`
    },
    STAFF_TODO: {
      name: 'To-Dos from Staff',
      stateParam: 'stafftodos',
      servantMethod: 'staffTodos',
      viewTitle: 'To-Dos from Staffs',
      emptyText: `You have no to-dos from staff.`
    }
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/types/todo_filter_enum.ts